"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InspectionListingDetailsDtoInspectionTypeEnum = void 0;
exports.instanceOfInspectionListingDetailsDto = instanceOfInspectionListingDetailsDto;
exports.InspectionListingDetailsDtoFromJSON = InspectionListingDetailsDtoFromJSON;
exports.InspectionListingDetailsDtoFromJSONTyped = InspectionListingDetailsDtoFromJSONTyped;
exports.InspectionListingDetailsDtoToJSON = InspectionListingDetailsDtoToJSON;
exports.InspectionListingDetailsDtoToJSONTyped = InspectionListingDetailsDtoToJSONTyped;
/**
 * @export
 */
exports.InspectionListingDetailsDtoInspectionTypeEnum = {
    Private: 'private',
    Open: 'open'
};
/**
 * Check if a given object implements the InspectionListingDetailsDto interface.
 */
function instanceOfInspectionListingDetailsDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('inspectionStartTime' in value) || value['inspectionStartTime'] === undefined)
        return false;
    if (!('inspectionEndTime' in value) || value['inspectionEndTime'] === undefined)
        return false;
    if (!('inspectionType' in value) || value['inspectionType'] === undefined)
        return false;
    return true;
}
function InspectionListingDetailsDtoFromJSON(json) {
    return InspectionListingDetailsDtoFromJSONTyped(json, false);
}
function InspectionListingDetailsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'inspectionStartTime': (new Date(json['inspectionStartTime'])),
        'inspectionEndTime': (new Date(json['inspectionEndTime'])),
        'inspectionType': json['inspectionType'],
    };
}
function InspectionListingDetailsDtoToJSON(json) {
    return InspectionListingDetailsDtoToJSONTyped(json, false);
}
function InspectionListingDetailsDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'inspectionStartTime': value['inspectionStartTime'].toISOString(),
        'inspectionEndTime': value['inspectionEndTime'].toISOString(),
        'inspectionType': value['inspectionType'],
    };
}
